import React from 'react';

import styled, { css, useTheme } from 'styled-components';

import CtaCard from 'components/CtaCard/CtaCard';
import CtaCardImage from 'components/CtaCard/CtaCardImage';
import InnerHtml from 'components/InnerHtml/InnerHtml';

import { ContentCardI } from 'interfaces/content-stack/modular-blocks/contentCard';

import { getModularBlockLinkData } from 'utils/modularBlockUtils';

const ContentCardTitle = styled.h3<{ $carousel?: boolean }>`
  ${({ $carousel, theme }) => css`
    text-transform: ${$carousel ? 'none' : 'uppercase'};
    font-weight: ${$carousel ? 700 : 500};
    margin-bottom: 1rem;
    font-family: ${$carousel ? theme.fonts.default : theme.fonts.fontFamilySecondary};
    font-size: ${$carousel ? '1.25rem' : '1.5rem'};

    @media (max-width: ${theme.breakpoints.lg}) {
      font-size: ${$carousel ? '1.15rem' : '1.25rem'};
    }
  `}
`;

const ContentCard = ({ data, carousel }: { data: ContentCardI; carousel?: boolean }) => {
  const { cardImage, header, textBody, cardImageAltText, cardLink, cornerImage } = data;
  const { link, target } = getModularBlockLinkData(cardLink?.linkUrl);
  const theme = useTheme();

  return (
    <CtaCard
      fullHeight
      bottomRightAlignment={carousel}
      isCornerImage={cornerImage}
      hoverBgColor={theme.colors.secondaryGray2}
      link={link}
      target={target}
      imgComponent={<CtaCardImage imageUrl={cardImage?.url ?? ''} imageAltText={cardImageAltText} loading='lazy' />}
    >
      {header && <ContentCardTitle $carousel={carousel}>{header}</ContentCardTitle>}
      {textBody && <InnerHtml fontWeight={'500'} richText={textBody} />}
    </CtaCard>
  );
};

export default ContentCard;
